"use client";

import { useSearchParams } from "next/navigation";
import { useMemo } from "react";
import dayjs from "dayjs";
import Container from "apps/website/components/layout/Container/Container";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import Text from "apps/website/components/base/Text/Text";
import {
  legacySizeCollectionMap,
} from "apps/website/components/base/Text/Text.map";
import {
  useTrackSuccessfulPurchase,
} from "apps/website/hooks/useTrackSuccessfulPurchase";

const DATE_FORMAT = "ddd MMM D YYYY";

export const LegacyScoopWelcome = () => {

  // const [ _deliveryDate, setDeliveryDate ] = useState<string | undefined>();

  const query = useSearchParams();
  const queryParam = query.get("litterDeliveryDate")?.trim() || query.get("deliveryDate")?.trim();
  const litterDeliveryDate = useMemo(() => {
    if (!queryParam) return "Arriving soon";
    try {
      const parsed = dayjs(queryParam);
      if (!parsed.isValid()) return "Arriving soon";
      return parsed.format(DATE_FORMAT).toUpperCase();
    } catch {
      return "Arriving soon";
    }
  }, [ queryParam ]);

  useTrackSuccessfulPurchase({
    // deliveryDateSetter: setDeliveryDate,
    doNotShowMentionMePopup: true,
  });

  return (
    <>
      <Section theme="green" size="lg">
        <Container>
          <Text tag="h1" size={legacySizeCollectionMap.titleMd} align="center" display="title">
            Success!
          </Text>
        </Container>
      </Section>
      <Section theme="brand" size={{ top: "2xl", bottom: "none" }}>
        <Container>
          <Text tag="h2" size={legacySizeCollectionMap.titleLg} align="center" display="title">
            You&apos;re all set
          </Text>
          <Spacer size="lg" />
          <Text size={legacySizeCollectionMap.titleMd} align="center" display="subtitle">
            { litterDeliveryDate }
          </Text>
          <Spacer size="md" />
          <Text size={legacySizeCollectionMap.bodyLg} align="center">
            Start counting down the days until you can fill your litter tray with a litter that&apos;s
          </Text>
        </Container>
      </Section>
    </>
  );
};
